<div class="card">
    <div [ngSwitch]="participant().type">
        <individual-header [participant]=participant() [totals]="totals()" *ngSwitchCase="ScorecardParticipantType.IndividualPlayer"/>
        <team-header [participant]=participant() [totals]="totals()" *ngSwitchCase="ScorecardParticipantType.Team"/>
    </div>
    <app-scorecard-row *ngFor="let row of rows(); trackBy: trackByRowName"
                       class="row"
                       [class]="row.classes"
                       [row]="row">
    </app-scorecard-row>
</div>
